export default {"src":"/_next/static/media/full_circle_filled_green.c19fb711.svg","height":107,"width":107,"blurWidth":0,"blurHeight":0};